import { render, staticRenderFns } from "./Layaways.vue?vue&type=template&id=5af814ba&scoped=true"
import script from "./Layaways.vue?vue&type=script&lang=js"
export * from "./Layaways.vue?vue&type=script&lang=js"
import style0 from "./Layaways.vue?vue&type=style&index=0&id=5af814ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af814ba",
  null
  
)

export default component.exports